// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"fe762799","335":"859c21e0","479":"eb59c1a3","708":"8d71ce26","791":"3455a236","793":"1e6a43a7","846":"cfac0b00"}[chunkId] + ".chunk.js";
};